/**
 * @file CallToActionSection.tsx
 * @description Final call-to-action band on the home page.
 */

/**
 * CallToActionSection component encourages visitors to contact Ultimind.
 */
export function CallToActionSection() {
  return (
    <section className="bg-gradient-to-r from-sky-600 to-blue-700">
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-6 px-4 py-10 text-slate-50 md:flex-row md:items-center md:px-6 md:py-12">
        <div>
          <h2 className="text-2xl font-semibold tracking-tight md:text-3xl">
            Ready to build your enterprise AI agent strategy?
          </h2>
          <p className="mt-3 max-w-xl text-sm text-sky-100 md:text-base">
            Partner with Ultimind to design, orchestrate, and deploy multi-agent
            systems that augment your teams, not replace them.
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          <a
            href="#/contact"
            className="rounded-full bg-slate-950 px-5 py-2.5 text-sm font-semibold text-sky-100 shadow-lg shadow-slate-900/60 transition hover:bg-slate-900"
          >
            Contact sales
          </a>
          <a
            href="#/technology"
            className="rounded-full border border-sky-100/60 px-5 py-2.5 text-sm font-semibold text-sky-50 hover:bg-sky-50/10"
          >
            Learn how it works
          </a>
        </div>
      </div>
    </section>
  )
}
